import { guardString } from "../strings";
import type { Nullable } from "../types";
import { Constants } from "./constants";

export function getReturnOrderNumberString(number: Nullable<number>) {
	if (!number) return guardString(null);
	return [
		Constants.RETURN_ORDER_NUMBER_PREFIX,
		number.toString().padStart(Constants.RETURN_ORDER_NUMBER_PADDING, "0"),
	].join("");
}
